import {
  RosterContent,
  RosterEventRepository,
  RosterFeature,
  RosterResourceRepository,
  RosterService,
  RosterStructureRepository,
} from '@softapps/pms/roster';
import { getModuleGroupById } from '@softline/application';
import { DeliveryNoteRosterService } from './services/delivery-note-roster.service';
import { DeliveryNoteRosterEventRepository } from './repositories/delivery-note-roster-event.repository';
import { DeliveryNoteRosterResourceRepository } from './repositories/delivery-note-resource.repository';
import { DeliveryNoteRosterStructureRepository } from './repositories/delivery-note-structure.repository';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { DnRosterMenuBar } from './components/menu-bar/dn-roster-menu-bar';
import { DeliveryNoteRosterMenuBarActionsRepository } from './repositories/delivery-note-roster-menu-bar-actions.repository';

export function withDeliveryNoteRoster(): RosterFeature<RosterContent> {
  return {
    name: 'delivery-note-roster',
    departmentHeadRequired: false,
    resourceFilterPlaceholder: 'Filtern...',
    virtualScroll: false,
    module: {
      name: 'delivery-note-roster',
      title: '#DN_ROSTER.TITLE',
      icon: 'fa-regular fa-calendars',
      color: 'bg-primary text-white',
      group: getModuleGroupById(12),
      //group: getModuleGroupByName(''),
      permission: 'SOFTAPPS.DELIVERY_NOTE_ROSTER',
    },
    info: {
      library: '@softline/delivery-note-roster',
      description: 'Lieferscheine im Dienstplaner auf Fahrer und Touren verteilen.',
    },
    providers: [
      { provide: RosterService, useClass: DeliveryNoteRosterService },
      { provide: RosterEventRepository, useClass: DeliveryNoteRosterEventRepository },
      {
        provide: RosterResourceRepository,
        useClass: DeliveryNoteRosterResourceRepository,
      },
      {
        provide: RosterStructureRepository,
        useClass: DeliveryNoteRosterStructureRepository,
      },
      DeliveryNoteRosterMenuBarActionsRepository,
    ],
    translations: { de, en },
    menuBar: DnRosterMenuBar,
    components: {
      eventComponent: () =>
        import('./components/event/dn-roster-event').then((o) => o.DnRosterEvent),
      calendarResourceComponent: () =>
        import('./components/resource/dn-roster-resource').then(
          (o) => o.DnRosterResource
        ),
      resourceComponent: () =>
        import('./components/artifacts-list/artifacts-list').then((o) => o.ArtifactsList),
    },
  };
}
